import { render, staticRenderFns } from "./AuthorBadge.vue?vue&type=template&id=70a1f127&"
import script from "./AuthorBadge.vue?vue&type=script&lang=js&"
export * from "./AuthorBadge.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/youtube/yt-live-chat-author-badge-renderer.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/youtube/yt-icon.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports